<script>
export let bgCssClass = 'bg-tertiary'
</script>

<section class="{`${bgCssClass} sectionx hero is-fullheight`}">
  <div class="hero-body">
    <div class="container">

      <div class="ioreveal animate__animated" data-anicss="animate__fadeInLeft">
        <!-- <h2><i class="fas fa-bus"></i> Public Transport</h2>
        <p>During the peak of the COVID-19 pandemic, public transport use plummeted and London, like many UK cities, is still experiencing reduced ridership due to ongoing personal distancing measures. </p> -->

        <p>
        During the peak of the COVID-19 pandemic, public transport use plummeted and London, like many UK cities, is still experiencing reduced ridership due to ongoing personal distancing measures.
        </p>
      </div>
      <br>
      <div class="ioreveal animate__animated animate__delay-2s"  style="animation-delay: 0.3s;" data-anicss="animate__fadeInRight">
        <p>
        As UK cities plan to exploit the Department for Transport pilot for shared eScooters as one way to help relieve crowding on public transport, Steer took the opportunity to analyse how Transport for London's Cycle Hire scheme, celebrating 10 years in operation this summer, performed through the peak of the crisis for both leisure and essential travel.
        </p>

        <!-- <span class="asterix">*gov.uk</span><br> -->
      </div>

      <!-- <div class="ioreveal animate__animated animate__delay-2s"  style="animation-delay: 0.3s;" data-anicss="animate__fadeInRight">
        <h2 class="marg-top"><i class="fas fa-bicycle"></i> Cycle Demand</h2>
        <p>With many people looking for public transport alternatives during lockdown how did Cycle Hire perform? </p>
      </div> -->

    </div>
  </div>
</section>
<!-- https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/890213/2020-06-04_COVID-19_Press_Conference_Slides.pdf -->

<style>
  h2 {
    font-size: 1.6rem;
  }
  p {
    font-size: 1.2rem;
  }
@media (max-width: 640px) {
  p {
    font-size: 1rem;
  }
  h2 {
    font-size: 1.2rem;
  }
  .fa-arrow-down {
    font-size: 2rem;
  }
}
</style>